'use es6';

import { forwardRef } from 'react';
import { DropTarget } from 'react-dnd-compat';
import { DropPositions, DragTypes } from '../../../constants/dragAndDrop';
import { jsx as _jsx } from "react/jsx-runtime";
const target = {
  canDrop(props, monitor) {
    /* Can promote yourself */
    if (props.id === monitor.getItem().id) return true;
    return !props.isParentDragging;
  },
  drop(props, monitor) {
    const {
      moveNode,
      targetId,
      targetParentId,
      menuId
    } = props;
    const nodeId = monitor.getItem().id;
    moveNode(nodeId, targetId, targetParentId, DropPositions.BOTTOM, menuId);
  }
};
export default function menuDropTarget() {
  return Component => {
    const DropTargetComponent = DropTarget(DragTypes.ADVANCED_MENUS_MENU_NODE, target, monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    }))(Component);
    const ForwardedDropTarget = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(DropTargetComponent, Object.assign({}, props, {
      ref: ref
    })));
    ForwardedDropTarget.displayName = `PromotingMenuDropTarget(${Component.displayName || Component.name || 'Component'})`;
    return ForwardedDropTarget;
  };
}